<template>
  <div class="slideshow noselect" v-on:click="activate()" v-bind:class="{active: isActive}">
    <div class="navigate prev" v-on:click.stop="prev()">
      <icon name="chevron-left" scale="2"></icon>
    </div>
    <div class="viewer" v-bind:style="items[idx].style"></div>
    <div class="navigate next" v-on:click.stop="next()">
      <icon name="chevron-right" scale="2"></icon>
    </div>
    <div class="close" v-on:click="close()">
      &times;
    </div>
    <div class="preloader">
      <img v-for="item in preload" v-bind:src="item.url">
    </div>
  </div>
</template>

<script>
export default {
  name: 'slideshow',
  props: ['items', 'selected'],
  data () {
    return {
      isActive: false,
      idx: this.selected,
      preload: []
    }
  },
  created () {
    this.preloadNext(2, 1)
    this.preloadNext(2, -1)
  },
  methods: {
    close () {
      this.$emit('close')
    },
    activate () {
      this.isActive = true
      var _this = this
      setTimeout(function () {
        _this.isActive = false
      }, 2000)
    },
    preloadNext (num, dir) {
      var idx = this.idx
      var i

      if (dir < 0) {
        for (i = 0; i < num; i++) {
          if (--idx < 0) idx = this.items.length - 1
          if (this.preload.indexOf(this.items[idx]) < 0) this.preload.push(this.items[idx])
        }
      } else {
        for (i = 0; i < num; i++) {
          if (++idx >= this.items.length) idx = 0
          if (this.preload.indexOf(this.items[idx]) < 0) this.preload.push(this.items[idx])
        }
      }
    },
    prev () {
      this.idx--
      if (this.idx < 0) this.idx = this.items.length - 1
      this.preloadNext(2, -1)
    },
    next () {
      this.idx++
      if (this.idx >= this.items.length) this.idx = 0
      this.preloadNext(2, 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.slideshow {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(255,255,255,0.9);
  cursor: pointer;
  z-index: 1100;
}
.slideshow .viewer {
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.slideshow .close {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  opacity: 0.5;
  padding: 0.5rem 1rem;
  z-index: 500;
  text-shadow: 0px 0px 3px 3px white;
  font-size: 15vh;
  line-height: 40px;
}
.slideshow .close .fa-icon {
  width: 75px;
  height: 75px;
}
.slideshow .close:hover {
  opacity: 0.8;
}
.slideshow img {
  max-width: 100%;
  max-height: 100%;
}
.slideshow .navigate {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100px;
  opacity: 0.1;
  background: black;
  cursor: pointer;
  color: white;
  transition: opacity ease 0.3s;
}
.slideshow.active .navigate,
.slideshow .navigate:active {
  opacity: 0.6;
}
.slideshow .navigate .fa-icon {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}
.slideshow .navigate.prev {
  left: 0;
  background: linear-gradient(to left, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
}
.slideshow .navigate.next {
  right: 0;
  background: linear-gradient(to right, rgba(0,0,0,0) 0%,rgba(0,0,0,1) 100%);
}
.slideshow .preloader {
  height: 0;
  width: 0;
  overflow: hidden;
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
</style>



// WEBPACK FOOTER //
// src/components/Slideshow.vue